// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mkb-clickable-selection[data-v-3180c59e]{margin-bottom:10px}.mkb-color-swatch[data-v-3180c59e]{position:relative;width:96px;height:46px;margin-right:auto}.mkb-swatch[data-v-3180c59e]{width:92px;height:44px;border-radius:5px}.mkb-colour-name[data-v-3180c59e]{font-size:.55rem;text-align:left;font-weight:500}mesh-kit-builder[tenant=bmco] .mkb-colour-name[data-v-3180c59e]{line-height:1.2;height:15px}", ""]);
// Exports
module.exports = exports;
